import * as Yup from "yup";

export const proffesionalExperienceValidationSchema = Yup.object().shape({
  company: Yup.string()
    .trim()
    .min(1, "Название компании должно быть не короче 1 символов")
    .max(150, "Название компании должно быть не длиннее 150 символов")
    .required("Название компании обязательно"),
  company_logo: Yup.string().url("Неверный формат URL логотипа").nullable(),
  description: Yup.string()
    .max(300, "Описание должно содержать максимум 300 символов")
    .required("Описание компании обязательно"),
  job_title: Yup.string()
    .trim()
    .min(2, "Минимум 2 символа")
    .max(150, "Максимум 150 символов")
    .required("Должность обязательна"),
  start_work: Yup.date()
    .typeError("Укажите корректную дату начала")
    .max(new Date(), "Дата начала не может быть в будущем")
    .required("Дата начала обязательна"),
  end_work: Yup.date()
    .nullable()
    .transform((curr, orig) =>
      orig === "" || orig === undefined ? null : curr
    )
    .min(
      Yup.ref("start_work"),
      "Дата окончания не может быть раньше даты начала"
    ),
});
